import { createSlice } from "@reduxjs/toolkit";
import {
  FraudByFicCategoryReportDataByCategory,
  FraudByFicCategoryReportDataByDateWindow,
  FraudByFicCategoryReportResponse,
} from "../../../api/tenantInternalReports";
import { RootState } from "../../../app/store";
import { getCurrentFyKey } from "../../../lib/utils";
import { fetchFraudByFicCategoryReportThunk } from "./fraudByFicCategoryReportThunk";

export interface FraudByFicCategoryReportState {
  rows: FraudByFicCategoryReportDataByCategory[];
  totals: FraudByFicCategoryReportDataByDateWindow[];
  reportName: string | null;
  selectedFy: string | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: FraudByFicCategoryReportState = {
  rows: [],
  totals: [],
  reportName: null,
  selectedFy: null,
  status: "idle",
  error: null,
};

const fraudByFicCategoryReportSlice = createSlice({
  name: "fraudByFicCategoryReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFraudByFicCategoryReportThunk.pending, (state) => {
        state.rows = [];
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        fetchFraudByFicCategoryReportThunk.fulfilled,
        (state, action) => {
          const report: FraudByFicCategoryReportResponse = action.payload;
          state.rows = report.data_by_category;
          state.totals = report.totals_by_date_window;
          state.reportName = report.config?.name ?? null;
          state.selectedFy = action.meta.arg?.fy ?? getCurrentFyKey();
          state.status = "succeeded";
        }
      )
      .addCase(
        fetchFraudByFicCategoryReportThunk.rejected,
        (state, action) => {
          state.status = "failed";
          state.error =
            action.payload ?? "Failed to fetch category-wise fraud summary";
        }
      );
  },
});

export const fraudByFicCategoryReportReducer =
  fraudByFicCategoryReportSlice.reducer;

export const selectFraudByFicCategoryRows = (state: RootState) =>
  state.fraudByFicCategoryReportData.rows;
export const selectFraudByFicCategoryTotals = (state: RootState) =>
  state.fraudByFicCategoryReportData.totals;
export const selectFraudByFicCategoryReportName = (state: RootState) =>
  state.fraudByFicCategoryReportData.reportName;
export const selectFraudByFicCategorySelectedFy = (state: RootState) =>
  state.fraudByFicCategoryReportData.selectedFy;
export const selectFraudByFicCategoryStatus = (state: RootState) =>
  state.fraudByFicCategoryReportData.status;
export const selectFraudByFicCategoryError = (state: RootState) =>
  state.fraudByFicCategoryReportData.error;
